
import React from 'react';

export default class DataView extends React.Component
{
  render()
  {
    return (
      <div>
        Data View
      </div>
    );
  }
}